import { treatErrorAs } from 'api/errors';
import { errorLevel } from 'constants/errors';

// requesters
import { requestAffiliateList } from 'affiliates/requesters';
import { requestPreferredDevice, requestDriveDevices } from 'devices/requesters';


// Finders
import { findExportOptions } from 'export-selector/finders';

export const requestExportSelectorOptions = () => {
  return (dispatch, getState) => {

    return Promise.resolve()
    .then( () => {
      dispatch(requestPreferredDevice({ dispatch, getState }));
      dispatch(requestDriveDevices({ dispatch, getState }));
      dispatch(requestAffiliateList({ dispatch, getState }));
    })
    .then( () => {
      findExportOptions({ dispatch, getState })
      .catch( treatErrorAs({ severity: errorLevel.INFO }) );
    });

  };
};
